module.exports = __webpack_public_path__ + "static/media/1005285.183d529f.jpg";